import {environment} from "../../environments/environment";

export class IUser {
  id: number;
  firstName: string;
  lastName: string;
  titleBefore?: string;
  titleAfter?: string;
}

export class User extends IUser {
  constructor(obj: IUser) {
    super();
    Object.assign(this, obj);
  }

  toString() {
    let result = '';
    if (this.titleBefore) {
      result = this.titleBefore + ' ';
    }
    result += this.firstName + ' ' + this.lastName;
    if (this.titleAfter) {
      result += ' ' + this.titleAfter;
    }
    return result;
  }

  profileUrl() {
    return environment.usoswebUrl + 'kontroler.php?_action=katalog2/osoby/pokazOsobe&os_id=' + this.id;
  }
}
